/**
 * Home feed tab keys
 */
export const HOME_FEED_TAB_KEYS = {
  FOR_YOU: 'forYou',
  NEWS: 'news',
};
